var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","color":"primary"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({on:{"click":_vm.copy}},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.text)+" ")])]}}])},[_c('span',[_vm._v("Copie")])])
}
var staticRenderFns = []

export { render, staticRenderFns }